'use client';

import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import type { ListingBySlugPartial } from '@utils/imperative-node-queries';
import { useFavoritedListingIds } from '@hooks';
import { FavoriteButton } from '@components/favorite-button';
import { HowItWorksBadge } from './how-it-works-badge';
import { ImageMural } from './image-mural';
interface ListingHeroProps {
  listing: ListingBySlugPartial;
}
export const ListingHero: React.FC<ListingHeroProps> = t0 => {
  const $ = _c(19);
  const {
    listing
  } = t0;
  const {
    isFavorited,
    setFavorited
  } = useFavoritedListingIds();
  const t1 = listing.id;
  let t2;
  if ($[0] !== isFavorited || $[1] !== listing.id) {
    t2 = isFavorited(listing.id);
    $[0] = isFavorited;
    $[1] = listing.id;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== listing.id || $[4] !== setFavorited) {
    t3 = nowFavorited => setFavorited(listing.id, nowFavorited);
    $[3] = listing.id;
    $[4] = setFavorited;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== listing.id || $[7] !== t2 || $[8] !== t3) {
    t4 = <div className="absolute right-6 top-4 z-20 rounded-lg sm:hidden"><FavoriteButton listingID={t1} listingIsFavorited={t2} size="md" onFavoritedSuccess={t3} /></div>;
    $[6] = listing.id;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const t5 = listing.city ? `${listing.city} Vacation Rental` : "Vacation Rental";
  let t6;
  if ($[10] !== listing.galleryAssets || $[11] !== t5) {
    t6 = <ImageMural altTag={t5} galleryAssets={listing.galleryAssets} shouldShowAllImages={true} shouldWatermarkImage={false} />;
    $[10] = listing.galleryAssets;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== listing.galleryAssets.length) {
    t7 = listing.galleryAssets.length > 0 ? <HowItWorksBadge /> : null;
    $[13] = listing.galleryAssets.length;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t4 || $[16] !== t6 || $[17] !== t7) {
    t8 = <div id="photos" className="relative overflow-hidden w-full pt-4 sm:mx-0 sm:pt-0 sm:mt-2 sm:rounded-xl scroll-mt-24">{t4}{t6}{t7}</div>;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
};